var r = /* @__PURE__ */ ((i) => (i.LoginId = "sio_login_id", i.BrowserSessionActiveId = "sio_browser_session_active_id", i))(r || {});
export {
  r as CookiesEnum
};
